module.exports = __webpack_public_path__ + "img/20191127163544360截图20191127161151310.09017d8a.jpg";